import React from 'react';
import { Box, Button, Typography } from '@lucid/lego';
import type { Theme } from '../utils';
import { ProspectTestDrive } from '../../../../../api/services/lupp/prospect/dto.test-drive-schedule';
import Table from './Table/Table';
import styles from './TestDriveTab.module.scss';

type TestDriveListProps = {
  theme: Theme;
  testDrives: ProspectTestDrive[];
  labels: Record<string, string>;
  onScheduleNew: () => void;
  onViewClick: (record: ProspectTestDrive) => void;
  locale?: string;
};

const TestDriveList: React.FC<TestDriveListProps> = ({
  theme,
  testDrives,
  labels,
  onScheduleNew,
  onViewClick,
  locale = 'en-US',
}) => {
  const invertedTheme = theme === 'dark' ? 'light' : 'dark';

  return (
    <Box>
      <Box>
        <Box className={styles.testDriveHeader}>
          <Box>
            <Typography variant="headline" size="small" color="white" theme={invertedTheme}>
              {labels?.['testDrive.listing'] ?? 'Test Drives'}
            </Typography>
            <Typography variant="body" size="medium" color="white" theme={invertedTheme}>
              {labels?.['testDrive.viewAndManage'] ?? 'View and manage all test drives'}
            </Typography>
          </Box>
          <Box className={styles.headerActions}>
            <Button
              type="primary"
              color="neutral"
              theme={invertedTheme}
              dataTestId="schedule-test-drive-button"
              gaComponent="prospect-details"
              label={labels?.['testDrive.scheduleNew'] ?? 'Schedule Test Drive'}
              handleClick={onScheduleNew}
            />
          </Box>
        </Box>
        <Box className={styles.loadingContainer}>
          <Table
            theme={theme}
            data={testDrives}
            labels={labels || {}}
            onViewClick={onViewClick}
            locale={locale}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TestDriveList;
